import { render, staticRenderFns } from "./AssistPanel.vue?vue&type=template&id=4884936d&scoped=true"
import script from "./AssistPanel.vue?vue&type=script&lang=ts"
export * from "./AssistPanel.vue?vue&type=script&lang=ts"
import style0 from "./AssistPanel.vue?vue&type=style&index=0&id=4884936d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884936d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4884936d')) {
      api.createRecord('4884936d', component.options)
    } else {
      api.reload('4884936d', component.options)
    }
    module.hot.accept("./AssistPanel.vue?vue&type=template&id=4884936d&scoped=true", function () {
      api.rerender('4884936d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/AssistPanel.vue"
export default component.exports